import { useEditMode } from "PFApp/booking/booking_edit_mode_store";
import { usePlaceholderBooking } from "PFApp/booking/components/booking_placeholder/hooks/use_placeholder_booking";
import { useBookingModuleStoreActions } from "PFApp/booking/store";
import { EditMode } from "PFApp/booking/types/edit_mode";
import useBookingCategories from "PFCore/hooks/use_booking_categories";
import { AccessLevel } from "PFTypes";
import { useCallback } from "react";

export const useIsBookingDraggable = () => {
  const { getBookingData, getAuditActivityData, getBookingDragAndDropData } = useBookingModuleStoreActions();
  const { getBookingCategory } = useBookingCategories();
  const { isBookingPlaceholder } = usePlaceholderBooking();
  const editMode = useEditMode();

  const checkIsBookingDraggable = useCallback(
    (bookingId: number): boolean => {
      if (editMode !== EditMode.Disabled) {
        return false;
      }

      const booking = getBookingData(bookingId)?.booking;
      if (!booking) {
        return false;
      }

      const category = getBookingCategory(booking.booking_category_id);
      const isCategoryHidden = !category || category.bookings_permissions === AccessLevel.Hidden;
      if (isCategoryHidden) {
        return false;
      }

      const { draggingMode, bookingId: draggingBookingId } = getBookingDragAndDropData();
      if (draggingMode !== null && draggingBookingId !== bookingId) {
        return false;
      }

      const auditActivity = booking.activity?.id
        ? getAuditActivityData(booking.activity.id)?.activity
        : undefined;
      const isExceptionState = auditActivity?.workflow_state === "exception";
      const isEditable =
        !booking.readonly &&
        booking.source === "ui" &&
        booking.booking_category_id != null && // eslint-disable-line eqeqeq
        !isBookingPlaceholder(booking) &&
        !isExceptionState;

      return isEditable;
    },
    [
      editMode,
      getAuditActivityData,
      getBookingCategory,
      getBookingData,
      getBookingDragAndDropData,
      isBookingPlaceholder
    ]
  );

  return { checkIsBookingDraggable };
};
